// Typelizer digest dd18f9ef441f356b3a0775980c20fbdc
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/:payment_id/invoices */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/invoices', params, options),
    method: 'post',
  }),
}
